<template>
    <div v-if="card" 
        class="w-full flex flex-column flex-1
        overflow-hidden
        text-left relative">
        <div class="w-full flex flex-column mb-3">
            <div class="w-full flex">
                <span v-if="card.id && isUserInGroup('admin') || isUserInGroup('manager')" class="flex text-600 mb-2">
                    {{ get_short_id(card.id) }} <span @click="copy(card.id)" class="flex pi pi-copy ml-2 text-600 text-xs cursor-pointer"></span>
                    <span class="ml-3 text-600">{{ card.bank_code }}</span>
                </span>
                <span v-if="card._id && isUserInGroup('admin') || isUserInGroup('manager')" class="flex text-600 mb-2">
                    {{ get_short_id(card._id) }} <span @click="copy(card._id)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
            </div>
            <div class="w-full flex">
                <span class="font-medium text-600 mb-2">
                    {{ getBankTitle(card.bank_code) }} ({{ get_card_type(card.type) }}) 
                </span>
                <span class=" text-white font-medium ml-2 text-xs p-1 border-round-md"
                    :class="(card.active) ? 'bg-green-400' : 'bg-yellow-600'">
                    {{ (card.active) ? 'Активна' : 'Не активна' }}
                </span>
            </div>
        </div>
        <div class="flex flex-column gap-2 mb-3">
            <span class="flex text-700 text-sm font-medium white-space-nowrap" v-if="card.fields && card.fields.fullname">
                {{ card.fields.fullname}}
            </span>
            <span class="flex text-700 text-lg font-medium white-space-nowrap" v-if="card.fields && card.fields.card_number">
                {{ format_card(card.fields.card_number)}}
            </span>
            <span class="flex text-700 text-lg font-medium white-space-nowrap" v-if="card.fields && card.fields.account_number">
                {{ card.fields.account_number}}
            </span>
            <span class="flex text-700 text-lg font-medium white-space-nowrap" v-if="card.fields && card.fields.phone_number">
                {{ card.fields.phone_number}}
            </span>
            <span class="flex text-700 text-lg font-medium white-space-nowrap" v-if="card.fields && card.fields.upi_id">
                {{ card.fields.upi_id}}
            </span>
            <span class="flex text-700 text-xs font-medium white-space-nowrap" v-if="card.fields && card.fields.wallet_address">
                {{ card.fields.wallet_address}}
            </span>
            <span class="flex text-700 text-lg font-medium white-space-nowrap" v-if="card.fields && card.fields.telegram">
                @{{ card.fields.telegram}}
            </span>
        </div>
        
        <div v-if="card.amount" class="flex flex-row xl:flex-row lg:flex-row">
            <div class="flex flex-1 flex-column">
                <span class="flex text-600 mb-2 text-sm">
                    Переводы за период:
                </span>
                <span class="flex text-700 text-xl font-medium white-space-nowrap">
                    {{ get_format_amount(card.amount, card.currency_code) }}
                </span>
            </div>
            <div v-if="editing && (isUserInGroup('admin') || isUserInGroup('manager') || isUserInGroup('merchant'))" class="flex flex-column ml-2">
                <span class="flex text-600 text-sm">
                    <Button icon="pi pi-pencil" @click="showForm()" class="border-round-lg surface-400 text-600 border-none" size="small"/>
                </span>
            </div>
        </div>
        <div class="absolute flex right-0 top-0 mr-0 mt-0">
            <span class="w-full">
                <AvatarGroup>
                    <Avatar :image="get_pays_image(card.type)" size="normal" shape="circle" class="surface-0"/>
                    <Avatar :image="getBankImage(card.bank_code)" size="normal" shape="circle" class="surface-0"/>
                </AvatarGroup>
            </span>
        </div>
    </div>


    <Dialog v-if="(isUserInGroup('admin') || isUserInGroup('manager') || isUserInGroup('merchant'))" header="Редактировать карту" modal class="flex flex-column border-none"
        v-model:visible="displayDialog" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '30vw'}" >

        <div v-if="card">
            <div class="w-full flex flex-column">
                <div v-if="card.active != undefined" class="w-full flex flex-column mb-3">
                    <span class="flex text-600 mb-2 text-sm">
                        Статус:
                    </span>
                    <SelectButton v-model="card.active" :options="card_statuses" optionLabel="name" optionValue="value" aria-labelledby="basic" />
                </div> 
                <div v-if="card.type" class="w-full flex flex-column mb-3">
                    <span class="flex text-600 mb-2 text-sm">
                        Тип карты:
                    </span>
                    <span class="flex text-700 text-xl font-medium white-space-nowrap">
                        {{ get_card_type(card.type) }}
                    </span>
                </div>
                <div v-if="card.currency_code" class="w-full flex flex-column mb-3">
                    <span class="flex text-600 mb-2 text-sm">
                        Валюта:
                    </span>
                    <span class="flex text-700 text-xl font-medium white-space-nowrap">
                        {{ card.currency_code }}
                    </span>
                </div> 
                <div v-if="card.bank_code" class="w-full flex flex-column mb-3">
                    <span class="flex text-600 mb-2 text-sm">
                        Банк:
                    </span>
                    <span class="flex text-700 text-xl font-medium white-space-nowrap">
                        {{ getBankTitle(card.bank_code) }}
                    </span>
                </div>

                <div v-if="card.fields" class="w-full flex flex-column mb-3">
                    <div v-if="card.fields.fullname" class="w-full flex flex-column mb-3">
                        <span class="flex text-600 mb-2 text-sm">
                            ФИО:
                        </span>
                        <span class="flex text-700 text-xl font-medium white-space-nowrap">
                            {{ card.fields.fullname }}
                        </span>
                    </div>
                    <div v-if="card.fields.card_number" class="w-full flex flex-column mb-3">
                        <span class="flex text-600 mb-2 text-sm">
                            Номер карты:
                        </span>
                        <span class="flex text-700 text-xl font-medium white-space-nowrap">
                            {{ format_card(card.fields.card_number)}}
                        </span>
                    </div>
                    <div v-if="card.fields.account_number" class="w-full flex flex-column mb-3">
                        <span class="flex text-600 mb-2 text-sm">
                            Номер счета:
                        </span>
                        <span class="flex text-700 text-xl font-medium white-space-nowrap">
                            {{ card.fields.account_number }}
                        </span>
                    </div> 
                    <div v-if="card.fields.phone_number" class="w-full flex flex-column mb-3">
                        <span class="flex text-600 mb-2 text-sm">
                            Телефон:
                        </span>
                        <span class="flex text-700 text-xl font-medium white-space-nowrap">
                            {{ card.fields.phone_number }}
                        </span>
                    </div>
                    <div v-if="card.fields.upi_id" class="w-full flex flex-column mb-3">
                        <span class="flex text-600 mb-2 text-sm">
                            UPI ID:
                        </span>
                        <span class="flex text-700 text-xl font-medium white-space-nowrap">
                            {{ card.fields.upi_id }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button v-if="isUserInGroup('admin') || isUserInGroup('manager')" label="Изменить админом" @click='updCardByAdmin()' :disabled="loading" class="flex"/>
                <div v-else>
                    <Button v-if="isUserInGroup('merchant')" label="Изменить" @click='updCardByMerchant()' :disabled="loading" class="flex"/>
                </div>
                <Button label="Закрыть" icon="pi pi-check" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :disabled="loading"/>
            </div>
        </div>
        <div v-else>
            <span>Нет данных карты</span>
        </div>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect';  
import Helper from '@/assets/js/Helper'
import { BankList, PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    props: ['card', 'editing'],
    data() {
        return {
            displayDialog: false,
            loading: false,
            card_statuses: [
                {name: 'Активна', value: true},
                {name: 'Не активна', value: false}
            ],
            lang: 'ru',
            bank_list: [],
            payment_systems: [],
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' }
    },
    methods: {
        showForm(){
            this.displayDialog = true
        },
        closeDialog(){
            this.displayDialog = false
        },
        getCardValue(status){
            switch(status){
                case 'Активна':
                    return true
                case 'Не активна':
                    return false
                default:
                    return false
            }
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        get_short_id(value){
            if(!value) return ''
            return this.helper.get_short_id(value)
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : null
        },
        get_pays_title(code){
            return this.helper.get_pays_title(code, this.$store.state.payment.payment_systems, this.lang)
        },
        get_pays_image(code){
            return this.helper.get_pays_image(code, this.$store.state.payment.payment_systems)
        },
        get_card_type(type){
            return this.helper.get_card_type(type)
        },
        format_card(number){
            return this.helper.format_card(number)
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency, 0)
        },
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        updCardByAdmin(){
            this.loading = true
            const id = (this.card.id) ? this.card.id : null
            if(!id) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Нет данных карты', life: 2000 })
                this.loading = false
                return
            }
            const data = {
                id: id,
                active: this.card.active 
            }
            this.connect.update_card_by_admin(data).then(res=>{
                if(res.result){
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Карта обновлена', life: 2000 })
                    this.displayDialog = false
                } else {
                    const err = (res.errors && res.errors.length>0) ? res.errors[0] : 'Ошибка'
                    this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: err, life: 2000 })
                }
                this.loading = false
            })
        },
        updCardByMerchant(){
            this.loading = true
            const id = (this.card.id) ? this.card.id : null
            if(!id) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Нет данных карты', life: 2000 })
                this.loading = false
                return
            }
            const data = {
                id: id,
                active: this.card.active 
            }
            this.connect.update_card_by_merchant(data).then(res=>{
                console.log(res)
                if(res.result){
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Карта обновлена', life: 2000 })
                    this.displayDialog = false
                } else {
                    const err = (res.errors && res.errors.length>0) ? res.errors[0] : 'Ошибка'
                    this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: err, life: 2000 })
                }
                this.loading = false
            })
        },
        async LoadBankList(){
            this.bank_list = await BankList.GetList(this.$store).then(r=>r)
            if(!this.bank_list || !this.bank_list.length) this.bank_list = []
        },
        async LoadPaymentSystems(){
            this.payment_systems = await PaymentSystemList.GetList(this.$store).then(r=>r)
            if(!this.payment_systems || !this.payment_systems.length) this.payment_systems = []
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.LoadBankList()
        this.LoadPaymentSystems()
    },
}
</script>
